import React, {useContext, useEffect} from "react";
import {Link} from 'react-router-dom'

import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';

import * as ReduxDataStatus from '../../utils/constants/ReduxDataStatus';
import {Loading} from '../custom/LoadingComponent'
import UserTabsRenderer from "./UserTabsRendererComponent";
import BucketContext from "../context/BucketContext";

const UserManagement = (props) => {
    console.log('___UserManagement___');

    const bucketContext = useContext(BucketContext);

    useEffect(() => {
        props.loadComponentData();

        if(bucketContext.bucket.mostRecentUserId != null) {
            console.log('Reseting the mostRecentUserId: ' + JSON.stringify(bucketContext.bucket.mostRecentUserId));
            bucketContext.setBucketValue({mostRecentUserId: null});
        }
    });



    if(props.dataStatus === ReduxDataStatus.IDLE || 
        props.dataStatus === ReduxDataStatus.LOADING) {
         return(
            <Container maxWidth="xl" >
            <Box px={{xs: 3, sm: 7}}>
                <Loading />
            </Box>
            </Container>
        );
    }
    else if(props.user != null) {

        return(
            <Container maxWidth="xl" >
            <Box px={{xs: 3, sm: 7}}>

                <Stack spacing={1} sx={{marginBottom: 2}}>
                    <Box>
                        <Breadcrumbs aria-label="breadcrumb" sx={{ mt: 1, mb: 1 }}>
                            <Link to='/users'>Utilizatori</Link>
                            <Typography color="text.primary">{props.user.generalSection.lastName} {props.user.generalSection.firstName}</Typography>
                        </Breadcrumbs>
                    </Box>

                    <Box>
                        <h3>{props.user?.generalSection.lastName} {props.user?.generalSection.firstName} - {props.client?.generalSection.clientName}</h3>
                    </Box>
                    <hr/>

                    <UserTabsRenderer 
                        user={props.user} 
                        client={props.client}
                        saveUser={props.patchUser} 
                        employers={props.employers}
                        worksites={props.worksites}    
                    />

                </Stack>

            </Box>
            </Container>
        );
    } else {
        console.log('Here Here....')

        return(
            <div></div>
        );
    }

}


export default UserManagement